import React from 'react'
import classnames from 'classnames'
import styles from './productCard.module.scss'
import Disclosure from '../../../components/Disclosure/Disclosure'
import { formatPrice } from '../pricing'
import { strings } from '../../../components/utils/translations'

const ProductCard = (props) =>
{
    const { product, pricing, isOpen, onToggle, children } = props

    const isFiveYear = pricing.isFiveYear
    const perYearHeadline = formatPrice(pricing.headlinePerYear)

    const discountsLabel = `${isFiveYear ? strings('seeCombinedDiscounts') : strings('seeVolumeDiscounts')}` +
                           (pricing.maxSavePercentage > 0 ?
                                ` (${strings('saveUpTo')} ${pricing.maxSavePercentage}%)` :
                                '')

    return (
        <div className={classnames(styles.productContainer, isFiveYear ? styles.highlighted : null)}>
            <div className={styles.product}>
                {
                    isFiveYear &&
                    <div className={styles.bestValueBadge}>{ strings('bestValue') }</div>
                }

                <div>
                    <div className={styles.productTop}>
                        <div className={styles.productImageContainer}>
                            <img className={styles.productImage} src={product.images?.[0]} alt="" />
                        </div>
                        <div className={styles.productText}>
                            <div className={classnames(styles.productTag, isFiveYear ? styles.golden : null)}>
                                { isFiveYear ? `${pricing.years} ${strings('years')}` : `1 ${strings('year')}` }
                            </div>
                            <div className={styles.productTitle}>
                                { strings('extraVirtualRemote') }
                            </div>
                        </div>
                    </div>

                    <div className={styles.productDescription}>
                        { isFiveYear ? strings('extraVirtualRemoteProductDesc5') : strings('extraVirtualRemoteProductDesc1') }
                    </div>

                    <div className={styles.headline}>
                        <div className={styles.headlinePrice}>
                            <span className={styles.headlineAmount}>{ formatPrice(pricing.headlinePrice) }€</span>
                            <span className={styles.headlineUnit}>{ strings('perUnit') }</span>
                        </div>
                        {
                            (perYearHeadline != null) &&
                            <div className={styles.headlineEquivalent}>
                                { `${strings('equivalentTo')} ${perYearHeadline}€/${strings('year')}` }
                            </div>
                        }
                    </div>

                    <Disclosure
                        id={`product-tiers-${product.id}`}
                        label={discountsLabel}
                        openLabel={strings('hideDiscounts')}
                        isOpen={isOpen}
                        onToggle={onToggle}
                        className={styles.tiersDisclosure}
                    >
                        <div className={styles.productTable}>
                            <div className={styles.productTableHeader}>
                                <span>{ strings('quantity') }</span>
                                <span>{ strings('perUnit') }</span>
                            </div>

                            <div className={styles.productTableContent}>
                                {
                                    pricing.rows.map(row =>
                                        <div key={row.key} className={styles.productTableItem}>
                                            <div className={styles.productTableItemLeft}>
                                                { row.quantityLabel }
                                            </div>
                                            <div className={styles.productTableItemRight}>
                                                <div className={styles.tierPrice}>
                                                    {
                                                        (row.basePrice != null) &&
                                                        <s className={styles.tierBasePrice}>{ formatPrice(row.basePrice) }€</s>
                                                    }
                                                    <span className={row.basePrice != null ? styles.tierFinalPriceDiscounted : null}>
                                                        { formatPrice(row.price) }€
                                                    </span>
                                                </div>
                                                {
                                                    (row.perYear != null) ?
                                                    <div className={styles.tierNote}>
                                                        { `${strings('equivalentTo')} ${formatPrice(row.perYear)}€/${strings('year')}` }
                                                    </div>
                                                    :
                                                    ((row.savePercentage > 0) &&
                                                    <div className={classnames(styles.tierNote, styles.tierSaving)}>
                                                        { `${strings('youSave')} ${row.savePercentage}%` }
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </Disclosure>
                </div>

                <div className={styles.productActions}>
                    { children }
                </div>
            </div>

            <div className={styles.greenBanner}>
                {
                    isFiveYear ?
                    <>
                        <div className={styles.greenBannerTitle}>
                            { strings('extraVRsGreenBanner5YearTitle') }
                        </div>
                        <div>
                            { strings('extraVRsGreenBanner5YearA') }
                            <span>{ `${pricing.maxSavePercentage}%` }</span>
                            { strings('extraVRsGreenBanner5YearB') }
                        </div>
                    </>
                    :
                    <div>
                        <span>{ `💡 ${strings('extraVRsGreenBanner1Year1')}` }</span>
                        { strings('extraVRsGreenBanner1Year2') }
                    </div>
                }
            </div>
        </div>
    )
}

export default ProductCard
